module.exports = __webpack_public_path__ + "img/110076.373b9c4c.png";